import { usePermissionAccessStore } from '@/stores/common/permissionAccess';

export const mainMenus = {
  financial: [
    { title: "حسابداری", route: "accounting", icon: "accounting.svg", actionName: "SinaPack.MainPage.Financial.Accounting" },
    { title: "خزانه داری", route: "treasury", icon: "cheque.svg", actionName: "SinaPack.MainPage.Financial.Treasury" },
    { title: "سامانه مودیان", route: "modian", icon: "moadian.svg", actionName: "SinaPack.MainPage.Financial.Moadian" },
    { title: "فروش", route: "sales", icon: "invoice.svg", actionName: "SinaPack.MainPage.Financial.Sale" },
    { title: "انبار", route: "warehouse", icon: "warehouse1.svg", actionName: "SinaPack.MainPage.Financial.Inventory" },
  ],
  official: [
    { title: "دبیرخانه", route: "secretariat", icon: "letter1.svg" },
    { title: "بایگانی", route: "archive", icon: "baygani1.svg" },
    { title: "ثبت تماس", route: "crm", icon: "tamas.svg" },
    { title: "حضور و غیاب", route: "attendance", icon: "Attendance1.svg" },
    { title: "حقوق دستمزد", route: "payroll", icon: "Salary-and-wages.svg" },
    { title: "پیام رسان", route: "messenger", icon: "Message.svg" },
  ],
  crafts: [
    { title: "سامانه مطب", route: "clinic", icon: "matabicon.svg" },
    { title: "سامانه فروشگاهی", route: "retail", icon: "clinic1.svg" },
    { title: "املاک", route: "real-estate", icon: "house-real-estate.svg" },
    { title: "رستوران", route: "restaurant", icon: "restaurant.svg" },
  ],
};

// map کمکی route → icon
export const softwareIconMap = Object.fromEntries(
  Object.values(mainMenus)
    .flat()
    .map((item) => [item.route, item.icon])
);

// map کمکی route → title
export const softwareTitleMap = Object.fromEntries(
  Object.values(mainMenus)
    .flat()
    .map((item) => [item.route, item.title])
);

export const sidebarItemsMap = {
  "accounting": [
    { title: "دفتر حساب‌ها", route: "account-books", icon: "accounting.svg", actionName: "SinaPack.MainPage.Financial.Accounting.Books"  },
    { title: "گزارش‌های مالی", route: "financial-reports", icon: "report1.svg" , actionName: "SinaPack.MainPage.Financial.Accounting.Reports" },
  ],
  "treasury": [
    {
      title: "ثبت چک",
      route: "record-check",
      icon: "cheque.svg",
      children: [
        { title: "چک پرداختی", route: "payable-check", icon: "cheque.svg" },
        { title: "چک دریافتی", route: "receivable-check", icon: "cheque.svg" },
        { title: "لیست چک‌ها", route: "check-list", icon: "invoice.svg" },
      ]
    },
    {
      title: "پایا/ ساتنا",
      route: "paya-satna",
      icon: "accounting.svg",
      children: [
        { title: "پرداخت پایا", route: "paya-payment", icon: "invoice.svg" },
        { title: "پرداخت ساتنا", route: "satna-payment", icon: "invoice.svg" },
        { title: "گزارش تراکنش‌ها", route: "transaction-report", icon: "report1.svg" },
      ]
    },
    { title: "واریز/برداشت", route: "bank-deposit-withdrawal", icon: "accounting.svg" },
    { title: "سفته و برات", route: "promissory-notes", icon: "cheque.svg" },
    { title: "درخواست وجه", route: "cash-request", icon: "invoice.svg" },
    { title: "صدور سند", route: "document-issuance", icon: "invoice.svg" },
    { title: "گزارش گیری", route: "reports", icon: "report1.svg" },
    { title: "راس گیری", route: "reconciliation", icon: "accounting.svg" },
    { title: "مغایرت گیری", route: "discrepancy", icon: "accounting.svg" },
    { title: "طرف حساب ها", route: "accounts-side", icon: "personels1.svg" },
    { title: "تعاریف", route: "definitions", icon: "defins1.svg" },
    { title: "تنظیمات", route: "treasury-settings", icon: "setting1.svg" },
  ],
  "modian": [
    // زیرمنوهای سامانه مودیان - فعلاً خالی
  ],
  "sales": [
    { title: "فاکتورهای فروش", route: "sales-invoices", icon: "invoice.svg" },
    { title: "مشتریان", route: "customers", icon: "personels1.svg" },
  ],
  "warehouse": [
    { title: "انبارها", route: "warehouses", icon: "warehouse1.svg" },
    { title: "کالاها", route: "products", icon: "store-microsoft.svg" },
  ],
  // اداری
  "crm": [
    { title: "لیست تماس ها", route: "registered-calls", icon: "tamas.svg" },
    { title: "مشتریان", route: "clients", icon: "personels1.svg" },
  ],
  "attendance": [
    { title: "لیست حضور", route: "attendance-list", icon: "Attendance1.svg" },
    { title: "گزارش‌ها", route: "attendance-reports", icon: "report1.svg" },
  ],
  "payroll": [
    // زیرمنوهای حقوق دستمزد - فعلاً خالی
  ],
  "messenger": [
    { title: "پیام‌ها", route: "messages", icon: "Message.svg" },
    { title: "تنظیمات پیام", route: "message-settings", icon: "setting1.svg" },
  ],
  "soroush": [
    { title: "دبیرخانه", route: "secretariat", icon: "letter1.svg" },
    { title: "کاربران", route: "users", icon: "personels1.svg" },
  ],
  // دبیرخانه جدید
  "secretariat": [
    { title: "مکاتبات ورودی", route: "incoming-documents", icon: "letter1.svg" },
    { title: "مکاتبات خروجی", route: "outgoing-documents", icon: "letter2.svg" },
    { title: "آرشیو اسناد", route: "document-archive", icon: "baygani1.svg" },
    { title: "گزارش‌ها", route: "secretariat-reports", icon: "report1.svg" },
  ],
  // بایگانی
  "archive": [
    { title: "بایگانی اسناد", route: "document-storage", icon: "baygani1.svg" },
    { title: "جستجوی اسناد", route: "document-search", icon: "baygani2.svg" },
    { title: "طبقه‌بندی", route: "document-classification", icon: "defins1.svg" },
    { title: "گزارش‌های بایگانی", route: "archive-reports", icon: "report1.svg" },
  ],
  // اصناف
  "retail": [
    { title: "داشبورد", route: "retail-dashboard", icon: "Message.svg", actionName: "SinaPack.MainPage.Crafts.Retail" },
  ],
  "clinic": [
    { title: "داشبورد", route: "clinic-dashboard", icon: "dashboard.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Dashboard" },
    { title: "بیماران", route: "clinic-patients", icon: "patients1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Patients" },
    { title: "ثبت نوبت", route: "clinic-reception", icon: "time1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Reception" },
    { title: "لیست نوبت‌ها", route: "clinic-receptionlist", icon: "appointments.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.ReceptionList" },
    { title: "ثبت قبض", route: "clinic-invoice", icon: "invoice1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Invoice" },
    { title: "انبار", route: "clinic-store", icon: "warehouse1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Store" },
    { title: "گزارش ها", route: "clinic-reports", icon: "report1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Reports" },
    { title: "تعاریف", route: "clinic-definitions", icon: "defins1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Definitions" },
    { title: "کاربران", route: "clinic-users", icon: "personels1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Users" },
    { title: "تنظیمات", route: "common/app-settings", icon: "setting1.svg", actionName: "SinaPack.MainPage.Crafts.Clinic.Settings" },
  ],
  "real-estate": [
    // زیرمنوهای املاک - فعلاً خالی
    { title: "داشبورد", route: "real-estate-dashboard", icon: "dashboard.svg", actionName: "SinaPack.MainPage.Crafts.RealEstate" },

  ],
  "restaurant": [
    // زیرمنوهای رستوران - فعلاً خالی
    { title: "داشبورد", route: "restaurant-dashboard", icon: "dashboard.svg", actionName: "SinaPack.MainPage.Crafts.Restaurant" },

  ],
};

// Returns a single canonical sidebar structure used across the app.
// This constructs three top-level groups: اتوماسیون مالی, اتوماسیون اداری, اصناف
// and attaches clinic-specific children to the `clinic` craft item when available.
export async function getGlobalSidebar() {
  const items = [];
  // For each top-level group (financial, official, crafts) we clone the
  // child items and, where a sidebarItemsMap entry exists for a route,
  // attach those children and propagate the parent's icon to them.
  function buildGroup(title, menuArray) {
    if (!menuArray || !menuArray.length) return;
    const children = menuArray.map((m) => {
      const item = { ...m };
      const sub = sidebarItemsMap[item.route] || [];
      if (sub.length) {
        // attach children but do NOT propagate the parent's icon.
        // The UI should only show the icon on the top-level menu item per user request.
        item.children = sub.map((child) => ({ ...child }));
      }
      return item;
    });
    items.push({ title, children });
  }

  // Try to fetch permissions for the current user and use them to decide which
  // top-level groups to include. If fetching fails or returns no relevant
  // permissions, fall back to showing all groups for backward compatibility.
  const permissionStore = usePermissionAccessStore();
  let permissions = [];
  try {
    const resp = await permissionStore.fetchPermissionAccess();
    const fromStore = Array.isArray(permissionStore.permissionAccessEntity)
      ? permissionStore.permissionAccessEntity
      : (permissionStore.permissionAccessEntity && Array.isArray(permissionStore.permissionAccessEntity.value)
        ? permissionStore.permissionAccessEntity.value
        : []);
    permissions = Array.isArray(resp) ? resp : fromStore;
  } catch (err) {
    // ignore - we'll fallback below
    permissions = [];
  }

  const getPermissionHasAccess = (p) => Boolean(p && (p.hasAccess ?? p.HasAccess ?? p.has_access));
  const getPermissionActionName = (p) => (p && (p.actionName ?? p.ActionName ?? p.action_name));
  const normalizeKey = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  const tokenizeActionName = (actionName) => {
    const s = String(actionName || '');
    // split by separators then also split PascalCase/CamelCase chunks
    const parts = s.split(/[^a-zA-Z0-9]+/).filter(Boolean);
    const tokens = [];
    for (const part of parts) {
      const spaced = part.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
      spaced.split(/\s+/).filter(Boolean).forEach(t => tokens.push(t.toLowerCase()));
    }
    return tokens;
  };
  const getRouteTokens = (routeOrTitle) => {
    const r = String(routeOrTitle || '').toLowerCase();
    const parts = r.split(/[^a-z0-9]+/i).filter(Boolean);
    const joined = parts.join('');
    return joined ? [...parts, joined] : parts;
  };

  const allowed = new Set();
  // Map to collect permission actionNames associated with a group (e.g., Financials)
  const groupPermissionActions = {
    financial: [],
    official: [],
    crafts: [],
  };

  const GROUP_BASE_ACTIONS = {
    financial: [ 'sinapack.mainpage.financial'],
    official: ['sinapack.mainpage.official'],
    crafts: ['sinapack.mainpage.crafts'],
  };

  const isUnderAnyBase = (actionName, bases) => {
    const an = String(actionName || '').trim().toLowerCase();
    return (bases || []).some(base => an === base || an.startsWith(`${base}.`));
  };

  if (permissions && permissions.length) {
    permissions.forEach((p) => {
      const name = getPermissionActionName(p);
      if (!p || !name || !getPermissionHasAccess(p)) return;
      const actionName = String(name).trim();
      const anLower = actionName.toLowerCase();

      if (isUnderAnyBase(anLower, GROUP_BASE_ACTIONS.financial)) {
        allowed.add('financial');
        groupPermissionActions.financial.push(actionName);
      }
      if (isUnderAnyBase(anLower, GROUP_BASE_ACTIONS.official)) {
        allowed.add('official');
        groupPermissionActions.official.push(actionName);
      }
      if (isUnderAnyBase(anLower, GROUP_BASE_ACTIONS.crafts)) {
        allowed.add('crafts');
        groupPermissionActions.crafts.push(actionName);
      }
    });
  }

  // If we detected allowed groups from permissions use them. If the permission service
  // returned a non-empty array but none of the known groups matched, that means the
  // user does not have access to these top-level menus and we should not build them.
  // If the permission service returned nothing (e.g., failed), fall back to previous
  // behaviour and show all groups so the UI remains usable.
  // Backward-compatible base keys for group-level permissions.
  // Note: backend may return both Financials (plural) and Financial (singular) trees.
  const ACTION_KEY_MAP = {
    financial: GROUP_BASE_ACTIONS.financial[0],
    official: GROUP_BASE_ACTIONS.official[0],
    crafts: GROUP_BASE_ACTIONS.crafts[0],
  };

  const allowedActionNames = new Set(
    (permissions || [])
      .filter(p => p && getPermissionHasAccess(p) && getPermissionActionName(p))
      .map(p => String(getPermissionActionName(p)).trim().toLowerCase())
  );
  const tokens = new Set();
  allowedActionNames.forEach((an) => tokenizeActionName(an).forEach(t => { if (t) tokens.add(t); }));

  // If a group has granular permissions (i.e., more than just the base actionName),
  // restrict the main menu children under that group to only those explicitly present.
  const groupAllowedRoutes = (() => {
    const result = {
      financial: null,
      official: null,
      crafts: null,
    };

    if (!permissions || permissions.length === 0) return result; // fallback allow all

    const permissionNorms = Array.from(allowedActionNames).map(normalizeKey);

    const compute = (groupKey, menuArray) => {
      const bases = GROUP_BASE_ACTIONS[groupKey] || [ACTION_KEY_MAP[groupKey]];
      const baseNorms = bases.map(normalizeKey);
      const groupActions = groupPermissionActions[groupKey] || [];
      const hasGranular = groupActions.some(a => !bases.includes(String(a || '').trim().toLowerCase()));
      if (!hasGranular) return null; // allow all items under this group

      // If group isn't allowed at all, hide everything.
      if (!allowed.has(groupKey)) return new Set();

      const set = new Set();
      (menuArray || []).forEach((m) => {
        const route = m && m.route;
        if (!route) return;
        const routeNorm = normalizeKey(route);

        const match = permissionNorms.some((anNorm) => baseNorms.some(bn => anNorm.includes(bn)) && anNorm.includes(routeNorm));
        if (match) set.add(route);
      });
      return set;
    };

    result.financial = compute('financial', mainMenus.financial);
    result.official = compute('official', mainMenus.official);
    result.crafts = compute('crafts', mainMenus.crafts);
    return result;
  })();

  const isAllowedRoute = (routeOrTitle, groupKey, actionName) => {
    if (!permissions || permissions.length === 0) return true; // fallback allow
    if (!routeOrTitle && !actionName) return false;

    // If group has no granular permissions (only the base actionName present), allow child.
    // If granular permissions exist, we must be strict for items that define an explicit actionName.
    const groupActions = groupPermissionActions[groupKey] || [];
    const baseActions = GROUP_BASE_ACTIONS[groupKey] || [ACTION_KEY_MAP[groupKey]];
    const hasGranular = groupActions.some(a => !baseActions.includes(String(a || '').trim().toLowerCase()));

    // If an explicit actionName is provided for this menu item, prefer it
    if (actionName) {
      const an = String(actionName).trim().toLowerCase();
      if (allowedActionNames.has(an)) return true;

      // Important: avoid cross-group token matches. If the backend returns granular permissions
      // for this group, a missing explicit actionName means NO access to this item.
      if (hasGranular) return false;
    }

    const r = String(routeOrTitle || '').toLowerCase();
    if (!hasGranular && allowed.has(groupKey)) return true;
    if (r && allowedActionNames.has(r)) return true;
    if (r && tokens.has(r)) return true;

    // Split route into tokens (e.g., 'clinic-dashboard' -> ['clinic','dashboard']) and check tokens
    const routeTokens = getRouteTokens(r);
    if (routeTokens.length) {
      // strict: accept if either the joined token exists, or all parts exist
      const joined = routeTokens[routeTokens.length - 1];
      const parts = routeTokens.slice(0, -1);
      if (joined && tokens.has(joined)) return true;
      if (parts.length && parts.every(tok => tokens.has(tok))) return true;
    }

    const titleTokens = String(routeOrTitle).split(/[^\w]+/).map(t => t.toLowerCase());
    if (titleTokens.some(t => tokens.has(t))) return true;
    return false;
  };

  const buildGroupWithPermissions = (title, menuArray, groupKey) => {
    if (!menuArray || !menuArray.length) return;
    const allowedRoutesSet = groupAllowedRoutes && groupAllowedRoutes[groupKey];
    const scopedMenuArray = (allowedRoutesSet instanceof Set)
      ? menuArray.filter(m => m && m.route && allowedRoutesSet.has(m.route))
      : menuArray;

    const children = scopedMenuArray.map((m) => ({ ...m }))
      .map((item) => {
        // attach children from sidebarItemsMap if available, but filter those children too
        const subs = sidebarItemsMap[item.route] || [];
        if (subs && subs.length) {
          const filteredSubs = subs.filter(s => isAllowedRoute(s.route, groupKey, s.actionName) || isAllowedRoute(s.title, groupKey, s.actionName));
          if (filteredSubs.length) item.children = filteredSubs.map(c => ({ ...c }));
        }
        return item;
      })
      .filter((item) => isAllowedRoute(item.route, groupKey, item.actionName) || isAllowedRoute(item.title, groupKey, item.actionName) || (item.children && item.children.length));

    if (children && children.length) items.push({ title, children });
  };

  if (permissions && permissions.length) {
    if (allowed.has('financial')) buildGroupWithPermissions('اتوماسیون مالی', mainMenus.financial, 'financial');
    if (allowed.has('official')) buildGroupWithPermissions('اتوماسیون اداری', mainMenus.official, 'official');
    if (allowed.has('crafts')) buildGroupWithPermissions('اصناف', mainMenus.crafts, 'crafts');
  } else {
    // Fallback: show everything if permission service failed or returned nothing
    buildGroupWithPermissions('اتوماسیون مالی', mainMenus.financial, 'financial');
    buildGroupWithPermissions('اتوماسیون اداری', mainMenus.official, 'official');
    buildGroupWithPermissions('اصناف', mainMenus.crafts, 'crafts');
  }

  return items;
}

// optional exported constant for convenience
export const globalSidebar = getGlobalSidebar();
